import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import NavbarAr from "@/components/NavbarAr";
import FooterAr from "@/components/FooterAr";
import MediaGallery from "@/components/MediaGallery";
import EventName from "@/components/EventName";
import Brand from "@/components/Brand";

// The Gathering page — APPROVED · governance-refined, Album 3 pending
// (Feb 2026).
//
// This page is approved under §13 Scope A — a governance-only
// refinement pass. Its media block (selection, sequencing, captions,
// and narrative treatment of the 27 currently rendered items) is
// EXPLICITLY DEFERRED to Archive Project Album 3 — The Gathering
// (see PRD §12.3 and §13.6.2). Do not modify the media block or
// its captions independently of the Album 3 curation package.
//
// ─────────────────────────────────────────────────────────────────
// APPROVED GOVERNANCE STATE (PRD §13.6) — do not modify without
// explicit re-authorization from the owner:
//
//   • Header overline: "Flagship convening"
//   • Header H1: "The Gathering brings the community together at
//     scale." — sentence case, single color, font-display,
//     text-5xl md:text-6xl, max-w-3xl. No gold accent, no
//     uppercase word spans. Aligned with the locked-set editorial
//     heading system.
//   • Intro paragraph: "The Gathering is CrewZNatioN's flagship
//     public convening, bringing the automotive and motorcycle
//     community together at Rimal Center in Riyadh. The
//     photographs and films below are drawn from the previous
//     edition."
//   • Media section H2: "Inside The Gathering." (no gold accent,
//     no uppercase spans).
//   • Next edition section: overline "Next edition" + heading
//     "The Gathering returns to Rimal Center, 1–3 October 2026."
//     "Coming Soon" device fully retired. Two-line wrap on this
//     heading is approved as-is (see PRD §13.6.1 item 6).
//
// Explicit exception: this treatment applies only to page heading
// typography. The CrewZNatioN brand lock-up and the established
// THE / GATHERING logo treatment used elsewhere on the site remain
// unchanged (Round 2 owner exception, recorded during governance
// refinement).
//
// This page is NOT admitted to the locked-set. Its final locked
// state depends on Album 3's curation package (PRD §13.6.3).
// ─────────────────────────────────────────────────────────────────

// Media for The Gathering — type: "image" | "video"
// Replace these with your actual gathering photos/videos as they come in
const GATHERING_MEDIA = [
    {
        type: "video",
        src: "https://customer-assets.emergentagent.com/job_crew-connect-68/artifacts/h5w3iur8_IMG_6053.MOV",
        thumbnail: "/gathering-video-poster.jpg",
        caption: "The Gathering — Official Film",
        captionNode: (<><EventName /> &mdash; Official Film</>),
        ratio: "square",
        featured: true,
    },
    {
        type: "video",
        src: "https://customer-assets.emergentagent.com/job_crew-connect-68/artifacts/xu0as3r1_copy_29E9D9E7-986B-4452-95ED-4F7E2C94C262.mov",
        thumbnail: "/clipA-poster.jpg",
        caption: "The Gathering — Curated Assembly",
        captionNode: (<><EventName /> &mdash; Curated Assembly</>),
        ratio: "square",
    },
    {
        type: "video",
        src: "https://customer-assets.emergentagent.com/job_crew-connect-68/artifacts/z6ui9se0_copy_E97380E9-E7DD-4CED-8064-DA0084DA2AFD.MOV",
        thumbnail: "/clipB-poster.jpg",
        caption: "Two Wheels, One Nation",
        ratio: "square",
    },
    {
        type: "image",
        src: "https://customer-assets.emergentagent.com/job_crew-connect-68/artifacts/3b3z9inq_IMG_3024.JPEG",
        caption: "Liberty Walk under the festival lights",
        ratio: "square",
    },
    {
        type: "image",
        src: "https://customer-assets.emergentagent.com/job_crew-connect-68/artifacts/tf8y44s5_F3209F41-0B30-4C13-8807-7FCBDFB18ABD.PNG",
        caption: "Not Tokyo — This is Riyadh",
        ratio: "square",
    },
    {
        type: "image",
        src: "https://customer-assets.emergentagent.com/job_crew-connect-68/artifacts/l3h9h8v0_35B1CA2D-6A44-433F-A0BB-19EE971F256E.JPEG",
        caption: "Corvette trio under the festival lights",
        ratio: "square",
    },
    {
        type: "image",
        src: "https://customer-assets.emergentagent.com/job_crew-connect-68/artifacts/bf40bx41_IMG_6392.jpg",
        caption: "Cadillac on three — Riyadh lowrider showcase",
        ratio: "square",
    },
    {
        type: "image",
        src: "https://customer-assets.emergentagent.com/job_crew-connect-68/artifacts/2ozf8do2_IMG_6391.jpg",
        caption: "240 wagon — stance, bike rack, attitude",
        ratio: "square",
    },
    {
        type: "image",
        src: "https://customer-assets.emergentagent.com/job_crew-connect-68/artifacts/we3lb970_IMG_6389.jpg",
        caption: "Lowriders take over the lot",
        ratio: "square",
    },
    {
        type: "image",
        src: "https://customer-assets.emergentagent.com/job_crew-connect-68/artifacts/jkfmumtp_3BB8CE40-B406-4080-A050-2146AC4C701C.JPG",
        caption: "Supra pair — Dragon World",
        ratio: "square",
    },
    {
        type: "image",
        src: "https://customer-assets.emergentagent.com/job_crew-connect-68/artifacts/5p2sn8iq_C0E8E69A-3485-47D6-8C46-571F161C1CE0.JPG",
        caption: "Audi RS7 under the festival string lights",
        ratio: "square",
    },
    {
        type: "image",
        src: "https://customer-assets.emergentagent.com/job_crew-connect-68/artifacts/5n6pde8o_FB21FACC-7058-44F0-AC7A-FA1B1432698C.JPG",
        caption: "Wide-body Supra commands the crowd",
        ratio: "square",
    },
    {
        type: "image",
        src: "https://customer-assets.emergentagent.com/job_crew-connect-68/artifacts/i9jgvsoa_E2BC40FB-A2E3-4D30-9FB2-DCCC242D3560.JPG",
        caption: "Mansory wheels meet the AMG S63",
        ratio: "square",
    },
    {
        type: "image",
        src: "https://customer-assets.emergentagent.com/job_crew-connect-68/artifacts/g5uc2mab_8D0AD18F-55F9-4A03-89B6-01C85BCDB62B.JPG",
        caption: "Crimson taillights in the night",
        ratio: "square",
    },
    {
        type: "image",
        src: "https://customer-assets.emergentagent.com/job_crew-connect-68/artifacts/eyed6v8w_E4BE464A-17CA-400C-9126-D68CE352C4E2.JPG",
        caption: "1958 in full bloom — purple lowrider with roses",
        ratio: "square",
    },
    {
        type: "image",
        src: "https://customer-assets.emergentagent.com/job_crew-connect-68/artifacts/urm54fjm_C497817B-6D54-425D-A0EB-08AF6CEF9C94.JPG",
        caption: "R34 Skyline GT-R — RB26 on display",
        ratio: "square",
    },
    {
        type: "image",
        src: "https://customer-assets.emergentagent.com/job_crew-connect-68/artifacts/j0tzxtfr_F65F8CDB-D592-46CC-A377-D04C1D9E2683.JPG",
        caption: "Fairlady Z — vintage Datsun under Rimal lights",
        ratio: "square",
    },
    {
        type: "image",
        src: "https://customer-assets.emergentagent.com/job_crew-connect-68/artifacts/xnttfluv_DDC71C0C-56FD-4A6D-8186-AC9CC6606405.JPG",
        caption: "WRX STI hawkeye — World Rally Blue, gold wheels",
        ratio: "square",
    },
    {
        type: "image",
        src: "https://customer-assets.emergentagent.com/job_crew-connect-68/artifacts/zfxdy5v9_4A885838-CE75-462E-B4EB-7D5ACFAD8D4A.JPG",
        caption: "Mk7 GTI lineup — Volkswagen tribute row",
        ratio: "square",
    },
    {
        type: "image",
        src: "https://customer-assets.emergentagent.com/job_crew-connect-68/artifacts/u65gd357_IMG-20260503-WA0051.jpg",
        caption: "Inside the meet — Riyadh comes together",
        ratio: "square",
    },
    {
        type: "image",
        src: "https://customer-assets.emergentagent.com/job_crew-connect-68/artifacts/l6qks9xt_16822D74-BA85-4787-93F8-9500F03D0098.JPG",
        caption: "Mk4 Golf R32 — deep blue, VR6 legend",
        ratio: "square",
    },
    {
        type: "image",
        src: "https://customer-assets.emergentagent.com/job_crew-connect-68/artifacts/z6eg4bms_211DE5C8-40F2-4F52-B234-06ADDF479B10.JPG",
        caption: "Widebody Skyline — Dragon World drop",
        ratio: "square",
    },
    {
        type: "video",
        src: "https://customer-assets.emergentagent.com/job_crew-connect-68/artifacts/lsu8gome_clip%201.MP4",
        thumbnail: "/clip1-poster.jpg",
        caption: "Yahya Shaggy's SRT — the build, the story",
        ratio: "square",
    },
    {
        type: "video",
        src: "https://customer-assets.emergentagent.com/job_crew-connect-68/artifacts/44vplzbs_clip%203.MP4",
        thumbnail: "/clip3-poster.jpg",
        caption: "Saud Rabiah — under the hood",
        ratio: "square",
    },
    {
        type: "video",
        src: "https://customer-assets.emergentagent.com/job_crew-connect-68/artifacts/ol6tj1bv_clip%204.MP4",
        thumbnail: "/clip4-poster.jpg",
        caption: "Saleh Alawwad — twin-turbo reveal",
        ratio: "square",
    },
    {
        type: "image",
        src: "https://customer-assets.emergentagent.com/job_crew-connect-68/artifacts/8deyxf22_9434ABE5-FD40-4044-9004-5C17D37BA6E0.JPG",
        caption: "BMW M6 meets matte blue Panamera — string-light night",
        ratio: "square",
    },
    {
        type: "image",
        src: "https://customer-assets.emergentagent.com/job_crew-connect-68/artifacts/jkh31imb_D6B14F73-40ED-493E-93BF-FF3A5915FC69.JPG",
        caption: "Porsche pair — matte Cayenne and crimson 911",
        ratio: "square",
    },
];

const STATS = [
    { v: "1,100+", l: "Vehicles & Motorcycles" },
    { v: "17,000+", l: "Visitors" },
    { v: "Riyadh", l: "Saudi Arabia" },
    { v: "Rimal Center", l: "Host Venue" },
];

// Arabic statistics — approved order and typography.
// Numeric values carry an LTR-isolated wrapper so the leading `+`
// stays attached to the number in RTL body flow.
const STATS_AR = [
    { v: "الرمال سنتر", l: "موقع الاستضافة", ltr: false },
    { v: "الرياض", l: "المملكة العربية السعودية", ltr: false },
    { v: "+17,000", l: "زائر", ltr: true },
    { v: "+1,100", l: "سيارة ودراجة نارية", ltr: true },
];

export default function Gathering({ locale = "en" }) {
    const Nav = locale === "ar" ? NavbarAr : Navbar;
    const PageFooter = locale === "ar" ? FooterAr : Footer;
    return (
        <div dir={locale === "ar" ? "rtl" : "ltr"} className="min-h-screen bg-[var(--crewz-bg)]" data-testid="gathering-page">
            <Nav />

            {/* HEADER */}
            <section className="px-6 md:px-12 lg:px-20 pt-20 pb-12 max-w-7xl mx-auto">
                <div className="flex items-center gap-3 mb-5">
                    <span className="gold-rule" />
                    <p className="overline overline-primary">
                        {locale === "ar" ? "الفعالية الأبرز" : "Flagship event"}
                    </p>
                </div>
                {locale === "ar" ? (
                    <>
                        <h1
                            className="font-display text-[28px] leading-[2.5] md:text-6xl md:leading-[1.4] text-[var(--crewz-text)] max-w-3xl"
                            data-testid="gathering-title"
                        >
                            حيث يجتمع عشاق السيارات<br className="hidden md:inline" /> والدراجات النارية في <EventName />
                        </h1>
                        <p className="font-body text-lg md:text-xl text-[var(--crewz-text)]/85 mt-8 max-w-3xl font-light leading-relaxed md:leading-loose">
                            انطلقت النسخة الأولى من <Brand /> من خلال تعاون جمعها مع عددٍ من المجموعات والجهات المعروفة في قطاع السيارات. ورغم أن لكل جهةٍ هويتها وأعضاءها، كانت رؤية <Brand /> أكبر من ذلك؛ أن تُوجد مساحة تُلغى فيها تلك الحدود، ليجتمع عشاق السيارات والدراجات النارية، والأندية، والعائلات، وشركاء القطاع، ضمن مجتمعٍ واحد يجمعه الشغف.
                        </p>
                        <p className="font-body text-lg md:text-xl text-[var(--crewz-text)]/85 mt-6 max-w-3xl font-light leading-relaxed md:leading-loose">
                            وفي شتاء 2026، تجسد <EventName /> هذه الرؤية على نطاق أوسع، امتدادًا لرؤية <Brand /> في بناء مجتمعٍ يجمع شغف السيارات والدراجات النارية تحت مظلةٍ واحدة، ليمتد أثرها من الرياض إلى مختلف أنحاء المملكة العربية السعودية، وما بعدها.
                        </p>
                    </>
                ) : (
                    <>
                        <h1
                            className="font-display text-5xl md:text-6xl text-[var(--crewz-text)] leading-[0.98] max-w-3xl"
                            data-testid="gathering-title"
                        >
                            <EventName /> brings the community together at scale.
                        </h1>
                        <p className="font-body text-lg md:text-xl text-[var(--crewz-text)]/85 mt-8 max-w-3xl font-light leading-relaxed">
                            The first edition was made possible through a collaboration between <Brand /> and several respected automotive groups. While each organization brought its own members and identity, <Brand />&rsquo;s vision was always larger: to create a place where those boundaries disappeared, allowing enthusiasts, clubs, riders, families, and industry to come together as one automotive and motorcycle community.
                        </p>
                        <p className="font-body text-lg md:text-xl text-[var(--crewz-text)]/85 mt-6 max-w-3xl font-light leading-relaxed">
                            <EventName /> Winter 2026 continues that vision on an even broader scale, reflecting <Brand />&rsquo;s ongoing vision and commitment to strengthening the community across Riyadh, throughout Saudi Arabia, and beyond.
                        </p>
                    </>
                )}
            </section>

            {/* STATS */}
            <section className="border-y border-white/5 bg-[var(--crewz-bg-3)]">
                <div className="px-6 md:px-12 lg:px-20 py-12 max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-10">
                    {(locale === "ar" ? STATS_AR : STATS).map((s, i) => (
                        <div
                            key={`${s.l}-${i}`}
                            className="text-center"
                            data-testid={`stat-${s.l.replace(/\s/g, "-").toLowerCase()}`}
                        >
                            <div
                                className={
                                    locale === "ar" && !s.ltr
                                        ? "font-arabic-display text-[1.9rem] md:text-[2.5rem] text-[var(--crewz-text)] whitespace-nowrap"
                                        : "font-display text-4xl md:text-5xl text-[var(--crewz-text)]"
                                }
                            >
                                {s.ltr ? <span dir="ltr">{s.v}</span> : s.v}
                            </div>
                            <p
                                className={
                                    locale === "ar"
                                        ? "overline mt-2 opacity-70 !text-[18px] md:!text-[22px]"
                                        : "overline mt-2 opacity-70"
                                }
                            >
                                {s.l}
                            </p>
                        </div>
                    ))}
                </div>
            </section>

            {/* MEDIA GALLERY */}
            <section className="px-6 md:px-12 lg:px-20 py-20 md:py-24 max-w-7xl mx-auto">
                {locale === "ar" ? (
                    <div className="mb-10">
                        <h2 className="font-display text-4xl md:text-5xl text-[var(--crewz-text)] leading-[0.98] [word-spacing:0.08em]">
                            معرض صور وفيديوهات <EventName />
                        </h2>
                    </div>
                ) : (
                    <div className="mb-10">
                        <div className="flex items-center gap-3 mb-4">
                            <span className="gold-rule" />
                            <p className="overline overline-primary">Photo &amp; Video Gallery</p>
                        </div>
                        <h2 className="font-display text-4xl md:text-5xl text-[var(--crewz-text)] leading-[0.98]">
                            Inside <EventName />.
                        </h2>
                    </div>
                )}

                <MediaGallery items={GATHERING_MEDIA} idPrefix="gathering" />
            </section>

            {/* NEXT EDITION */}
            <section className="section-light">
                <div className="px-6 md:px-12 lg:px-20 py-28 max-w-4xl mx-auto text-center">
                    {locale === "ar" ? (
                        <>
                            <p className="overline overline-primary mb-6">الموعد القادم</p>
                            <h3 className="font-display text-4xl md:text-5xl text-[var(--crewz-text-dark)] leading-[0.98] max-w-3xl mx-auto">
                                تعود <EventName surface="light" /> إلى الرمال سنتر، خلال الفترة من 1 إلى 3 أكتوبر 2026
                            </h3>
                        </>
                    ) : (
                        <>
                            <p className="overline overline-primary mb-6">Next edition</p>
                            <h3 className="font-display text-4xl md:text-5xl text-[var(--crewz-text-dark)] leading-[0.98] max-w-3xl mx-auto">
                                <EventName surface="light" /> returns to Rimal Center, 1&ndash;3 October 2026.
                            </h3>
                        </>
                    )}
                </div>
            </section>

            <PageFooter />
        </div>
    );
}
